import { ApiClient } from '@/services/api-client';
import { useAuth } from '@clerk/nextjs';
import { useQuery } from '@tanstack/react-query';

const useInstagramConnection = (options?: { refetchInterval?: number }) => {
  const { orgId } = useAuth();
  const { data, ...props } = useQuery({
    queryKey: ['instagram.account.list', orgId],
    queryFn: async () => {
      const response = await ApiClient.integration.getInstagramAccounts();
      return response.data;
    },
    refetchInterval: options?.refetchInterval,
    staleTime: 30_000,
  });
  return {
    isInstagramConnected: !!data?.Accounts.length,
    connectedAccounts: data?.Accounts,
    ...props,
  };
};

export { useInstagramConnection };
